import React from 'react'

/**
 * Pull-to-refresh state that only reflects a refresh the user started.
 *
 * Don't bind RefreshControl's `refreshing` to React Query's `isRefetching`:
 * background refetches (focus, interval) then toggle the native spinner
 * while the screen is off-screen or mid-transition, and iOS can leave the
 * list's content offset stuck at the spinner inset — the first row sits
 * ~60pt down with an empty gap above it after navigating back.
 */
export function usePullToRefresh(refetch: () => Promise<unknown>) {
  const [refreshing, setRefreshing] = React.useState(false)
  const onRefresh = React.useCallback(async () => {
    setRefreshing(true)
    try {
      await refetch()
    } finally {
      setRefreshing(false)
    }
  }, [refetch])
  return { refreshing, onRefresh }
}
